<template>
  <div class="input-range-select">
    <div class="input-range-select__labels">
      <div class="input-range-select__label">
        <span v-html="unitsBefore" />{{ formatValue(this.valueRange[0]) }}<span v-html="unitsAfter" />
      </div>
      <div class="input-range-select__label">
        <span v-html="unitsBefore" />{{ formatValue(this.valueRange[1]) }}<span v-html="unitsAfter" />
      </div>
    </div>
    <div class="slider">
      <vue-slider v-model="valueRange" @change="onChange" v-bind="options" />
    </div>
  </div>
</template>
<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import _ from 'lodash'

export default {
  props: ['limits', 'step', 'unitsAfter', 'unitsBefore', 'value', 'format'],
  components: {
    VueSlider
  },

  data () {
    return {
      valueRange: this.limits,
      options: {
        enableCross: false,
        eventType: 'auto',
        width: 'auto',
        dotHeight: null,
        dotWidth: null,
        min: this.limits[0],
        max: this.limits[1],
        tooltip: 'none',
        interval: this.step || 1
      }
    }
  },

  mounted () {
    this.$emit('value-changed', this.valueRange)
  },

  methods: {
    onChange () {
      this.$emit('value-changed', this.valueRange)

      this.debounceChange()
    },

    debounceChange: _.debounce(function () {
      this.$emit('input', this.valueRange)
    }, 200),

    formatValue (value) {
      if (typeof this.format === 'function') {
        return this.format(value)
      }

      return value
    }
  }
}
</script>
<style lang="scss">
.input-range-select {
  position: relative;

  &__selection-labels {
    display: flex;
    display: none;
    font-size: 1.6rem;
    justify-content: space-between;
    margin-top: 2rem;
  }

  &__inputs {
    background: transparent;
    border: .1rem solid rgba(255, 255, 255, 1);
    border-radius: .5rem;
    height: 3rem;
    position: relative;
  }

  &__labels {
    color: rgb(216, 216, 216);
    display: flex;
    font-size: 1rem;
    justify-content: space-between;
    margin-top: .2rem;
  }
  
  input[type=range] {
    appearance: none;
    background: transparent;
    box-sizing: border-box;
    height: 3rem;
    left: -.1rem;
    margin: 0;
    overflow: hidden;
    outline: none;
    padding: 0;
    pointer-events: none;
    position: absolute;
    top: -.1rem;
    width: calc(100% + .2rem);
    z-index: 1;

    &:active, &:focus {
      outline: none;
    }

    &::-webkit-slider-thumb {
      appearance: none;
      background-color: transparent;
      background-image: url("/assets/arrows.png");
      background-position: center;
      background-repeat: no-repeat;
      background-size: 1rem;
      border: none;
      border-radius: .5rem;
      box-sizing: border-box;
      height: 3rem;
      border: .1rem solid rgba(255, 255, 255, .85);
      padding: 0;
      pointer-events: all;
      position: relative;
      width: 3rem;
      z-index: 5;
    }

    &::-moz-range-thumb {
      appearance: none;
      background-color: transparent;
      background-image: url("/assets/arrows.png");
      background-position: center;
      background-repeat: no-repeat;
      background-size: 1rem;
      border: none;
      border-radius: .5rem;
      box-sizing: border-box;
      height: 3rem;
      border: .1rem solid rgba(255, 255, 255, .85);
      padding: 0;
      pointer-events: all;
      position: relative;
      width: 3rem;
      z-index: 5;
    }
  }

  .range-bg {
    background-color: rgba(#fff, .25);
    border-radius: .5rem;
    position: absolute;
    top: 0;
    bottom: 0;
    left: calc(0%);
    right: 0;
  }
}

.slider {
  margin-bottom: 1.5rem;
  pointer-events: auto;

  * {
    pointer-events: auto;
  }
}

// vue slider component
.vue-slider {
  padding: 0 !important;
  height: auto !important;
  &:hover {
    .vue-slider-rail {
      background-color: rgba(49, 49, 49, 0.25);
    }

    .vue-slider-process {
      background-color: transparent;
    }

    .vue-slider-dot-handle:hover {
      border-color: #fff;
    }
  }
}

// slider track
.vue-slider-rail {
  background-color: #60664700;
  border: 0.1rem solid rgba(255, 255, 255, 0.85);
  border-radius: .5rem;
  height: 3em !important; 
  margin-left: 1.5em;
  width: calc(100% - 3em) !important;

  .vue-slider-process {
    background-color: rgba(0,0,0, 0.25);
    border-radius: .5rem;
  }
}

// slider handle
.vue-slider-dot {
  height: 3em !important;
  width: 3em !important;

  .vue-slider-dot-handle {
    background-color: var(--brand-color);
    background-image: url("/assets/arrows.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 1rem;
    border: 0.1rem solid rgba(255, 255, 255, 0.85);
    border-radius: .5rem;
  }
}

</style>
